import { useBucket } from '@mc/experiments-react'

const NEW_FOR_BUSINESS_PAGE = 'web_flw-194_new_for_business_page_v1'

export const useIsNewForBusinessPageEnabled = () =>
  useBucket(NEW_FOR_BUSINESS_PAGE) === 'variant_1'
